import { VFlow } from 'bold-ui'

import { NewsContentProps } from './news-commons'

export function NewsSectionContent(props: Readonly<NewsContentProps>) {
  return <VFlow vSpacing={0.5}>{props.children}</VFlow>
}
